import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
//import * as apiUser from 'apiSaga/apiUser';
import * as apiCommon from 'apiSaga/apiCommon';
import createRequestSaga from 'apiSaga/createRequestSaga';

/***** 액션 타입 선언 *****/

// 0. Response 초기화
const INIT_COM_CODE_LIST_RESP = 'com/INIT_COM_CODE_LIST_RESP'; //공통코드 초기화

// 1. 공통 코드 조회
const GET_COM_CODE_LIST = 'com/GET_COM_CODE_LIST';
const GET_COM_CODE_LIST_SUCCESS = 'com/GET_COM_CODE_LIST_SUCCESS';
const GET_COM_CODE_LIST_FAILURE = 'com/GET_COM_CODE_LIST_FAILURE';

// 임시비밀번호 발송
const INIT_SEND_TEMP_PWD_ADMIN_RESP = 'com/INIT_SEND_TEMP_PWD_ADMIN_RESP';

const SEND_TEMP_PWD_ADMIN = 'com/SEND_TEMP_PWD_ADMIN';
const SEND_TEMP_PWD_ADMIN_SUCCESS = 'com/SEND_TEMP_PWD_ADMIN_SUCCESS';
const SEND_TEMP_PWD_ADMIN_FAILURE = 'com/SEND_TEMP_PWD_ADMIN_FAILURE';

// 공통_상단 우측_알림팝업_리스트
const SELECT_ALRAM_POPUP_LIST = 'common/SELECT_ALRAM_POPUP_LIST';
const SELECT_ALRAM_POPUP_LIST_SUCCESS = 'common/SELECT_ALRAM_POPUP_LIST_SUCCESS';
const SELECT_ALRAM_POPUP_LIST_FAILURE = 'common/SELECT_ALRAM_POPUP_LIST_FAILURE';

// 공통_상단 우측_알림팝업_확인체크
const UPDATE_ALRAM_POPUP_CHK = 'common/UPDATE_ALRAM_POPUP_CHK';
const UPDATE_ALRAM_POPUP_CHK_SUCCESS = 'common/UPDATE_ALRAM_POPUP_CHK_SUCCESS';
const UPDATE_ALRAM_POPUP_CHK_FAILURE = 'common/UPDATE_ALRAM_POPUP_CHK_FAILURE';

// 1. 공통 코드 조회
export const initComCodeListResp = createAction(INIT_COM_CODE_LIST_RESP); // 공통코드 response 초기화
export const getSysCodeList = createAction(GET_COM_CODE_LIST, (sysGroupCode) => sysGroupCode);
const getSysCodeListSaga = createRequestSaga(GET_COM_CODE_LIST, apiCommon.getSysCodeList); // 공통코드

// 2. 임시비밀번호 발송
export const initSendTempPwdAdminResp = createAction(INIT_SEND_TEMP_PWD_ADMIN_RESP);
export const sendTempPwdAdmin = createAction(SEND_TEMP_PWD_ADMIN, (userInfo) => userInfo);
const sendTempPwdAdminSaga = createRequestSaga(SEND_TEMP_PWD_ADMIN, apiCommon.sendTempPwdAdmin);

// 공통_상단 우측_알림팝업_리스트
export const selectAlramPopupList = createAction(SELECT_ALRAM_POPUP_LIST, (req) => req);
const selectAlramPopupListSaga = createRequestSaga(SELECT_ALRAM_POPUP_LIST, apiCommon.selectAlramPopupList);

// 공통_상단 우측_알림팝업_확인체크
export const udpateAlramPopupChkYn = createAction(UPDATE_ALRAM_POPUP_CHK, (req) => req);
const udpateAlramPopupChkYnSaga = createRequestSaga(UPDATE_ALRAM_POPUP_CHK, apiCommon.udpateAlramPopupChkYn);

// apiUserSaga
export function* apiCommonSaga() {
  yield takeLatest(GET_COM_CODE_LIST, getSysCodeListSaga);
  yield takeLatest(SEND_TEMP_PWD_ADMIN, sendTempPwdAdminSaga);
  yield takeLatest(SELECT_ALRAM_POPUP_LIST, selectAlramPopupListSaga);
  yield takeLatest(UPDATE_ALRAM_POPUP_CHK, udpateAlramPopupChkYnSaga);
}

// 초기 상태를 선언
// 요청의 로딩 중 상태는 loading 객체에서 관리
const initialState = {
  getComCodeListResp: null,
  sendTempPwdAdminResp: null,
  selectAlramPopupListResp: null,
  udpateAlramPopupChkResp: null,
};

const apiCommonResp = handleActions(
  {
    // 0. Response 초기화

    [INIT_COM_CODE_LIST_RESP]: (state, action) => ({
      //문서관리
      ...state,
      getSysCodeListResp: null,
    }),
    // 1. 문서조회 타입 코드 조회
    [GET_COM_CODE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getSysCodeListResp: action.payload,
    }),
    [GET_COM_CODE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getSysCodeListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    // 임시비밀번호 발송
    [INIT_SEND_TEMP_PWD_ADMIN_RESP]: (state, action) => ({
      ...state,
      sendTempPwdAdminResp: null,
    }),

    // 임시비밀번호 발송
    [SEND_TEMP_PWD_ADMIN_SUCCESS]: (state, action) => ({
      ...state,
      sendTempPwdAdminResp: action.payload,
    }),
    [SEND_TEMP_PWD_ADMIN_FAILURE]: (state, action) => ({
      ...state,
      sendTempPwdAdminResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 공통_상단 우측_알림팝업_리스트
    [SELECT_ALRAM_POPUP_LIST_SUCCESS]: (state, action) => ({
      ...state,
      selectAlramPopupListResp: action.payload,
    }),
    [SELECT_ALRAM_POPUP_LIST_FAILURE]: (state, action) => ({
      ...state,
      selectAlramPopupListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    // 공통_상단 우측_알림팝업_확인체크
    [UPDATE_ALRAM_POPUP_CHK_SUCCESS]: (state, action) => ({
      ...state,
      udpateAlramPopupChkResp: action.payload,
    }),
    [UPDATE_ALRAM_POPUP_CHK_FAILURE]: (state, action) => ({
      ...state,
      udpateAlramPopupChkResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
  },
  initialState
);

export default apiCommonResp;
